import { useEffect } from 'react';

export default function StructuredData() {
  useEffect(() => {
    const existingScript = document.getElementById('structured-data-soclimate');
    if (existingScript) existingScript.remove();

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'SOCLIMATE',
      url: 'https://www.soclimate.fr',
      logo: 'https://www.soclimate.fr/logoNavigateur.png',
      image: 'https://www.soclimate.fr/logoNavigateur.png',
      description:
        'SOCLIMATE accompagne particuliers et professionnels pour l’installation, l’entretien et le dépannage de climatisation, pompe à chaleur et ventilation.',
      telephone: '+33618011895',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'FR',
      },
      areaServed: 'France',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+33618011895',
        contactType: 'customer service',
        areaServed: 'FR',
        availableLanguage: ['French'],
      },
    };

    const script = document.createElement('script');
    script.id = 'structured-data-soclimate';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('structured-data-soclimate');
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, []);

  return null;
}